import React from "react";
import { cn } from "@/lib/utils";

const STYLES = {
  Active: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
  Completed: "bg-slate-200 text-slate-700 dark:bg-slate-700/60 dark:text-slate-200",
  "On Hold": "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
};

export default function StatusBadge({ status, className }) {
  const value = status || "Active";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium",
        STYLES[value] || STYLES.Active,
        className
      )}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {value}
    </span>
  );
}